/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Settings_HeadingInputs */

const en_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Settings`)
};

const fr_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametres d'importation`)
};

const de_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importeinstellungen`)
};

const it_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di importazione`)
};

const ru_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт настроек`)
};

const es_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de importación`)
};

const zh_cn2_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入设置`)
};

const ja_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポート設定`)
};

const hi_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग आयात करना`)
};

const pt_pt2_plain_text_import_settings_heading = /** @type {(inputs: Plain_Text_Import_Settings_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de importação`)
};

/**
* | output |
* | --- |
* | "Import Settings" |
*
* @param {Plain_Text_Import_Settings_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_settings_heading = /** @type {((inputs?: Plain_Text_Import_Settings_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Settings_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_settings_heading(inputs)
	if (locale === "de") return de_plain_text_import_settings_heading(inputs)
	if (locale === "it") return it_plain_text_import_settings_heading(inputs)
	if (locale === "ru") return ru_plain_text_import_settings_heading(inputs)
	if (locale === "es") return es_plain_text_import_settings_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_settings_heading(inputs)
	if (locale === "ja") return ja_plain_text_import_settings_heading(inputs)
	if (locale === "hi") return hi_plain_text_import_settings_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_settings_heading(inputs)
	return en_plain_text_import_settings_heading(inputs)
});